import React, { useContext } from "react";
import "../styles/basketItemDiscount.css";

export default function SummaryItemTileDefaultDetails(props) {
  return (
    <>
      {props.isMosaic && (
        <div>
          <p>{props.subTitle}</p>
        </div>
      )}
      {!props.isMosaic && props.format !== undefined && (
        <div className="summary_box_item">
          <p>
            {props.sizePlaceholder} {props.colorPlaceholder}
          </p>
        </div>
      )}
    </>
  );
}
